import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from '@capacitor/status-bar';
import { configureStatusBar } from './configureStatusBar';
import store from '../../store';

export const configureApp = async logout => {
    if (Capacitor.isNativePlatform()) {
        // Disparamos la action a la store para setear la version de la app
        await store.dispatch('setAppVersion');
        // Activamos las analytics de Firebase
        await FirebaseAnalytics.setEnabled({ enabled: true });
        console.log(`Cobas app version: ${store.getters.getAppVersion}`);

        if (logout) {
            localStorage.clear();
            this.$store.dispatch('setDefaultStore');
        }

        await SplashScreen.hide();
        if (Capacitor.getPlatform() === 'ios') {
            await StatusBar.show();
        }
        // Configuramos el status bar -> debemos configurar el statusbar después de ocultar la splashscreen
        // porque sino, se desconfigura
        await configureStatusBar();
    }
};
